import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import AuthSelectors from 'Stores/Auth/Selectors'
import AuthActions from 'Stores/Auth/Actions'
import OperatorUserActionsSelectors from 'Stores/OperatorUserActions/Selectors'
import OperatorUserActionsActions from 'Stores/OperatorUserActions/Actions'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import Styles from './OperatorUserProfile.module.css'
import { Colors } from 'Theme'
import LoadingBar from 'react-top-loading-bar'
import {
  IFAvatar,
  IFButton,
  IFDialog,
  IFFilter,
  IFGroupingComponent,
  IFModal,
  IFSkeleton,
  IFText,
} from 'Components'
import { useTranslation } from 'react-i18next'
import Scrollbars from 'react-custom-scrollbars-2'
import moment from 'moment'
import ChangePasswordForm from './ChangePasswordForm'
import ReactCountryFlag from 'react-country-flag'
import RequestState from 'Enums/RequestState'
import { Edit } from '@mui/icons-material'
import { TextField } from '@mui/material'
import InfinityEnums from 'Enums/InfinityEnums'
import { useLocation } from 'react-router-dom'
import OperatorUserAction from 'Stores/OperatorUser/Actions'
import FormControl from '@mui/material/FormControl'
import OperatorUserActionList from 'Containers/OperatorUserActionList/OperatorUserActionList'
import { CheckPicker } from 'rsuite'
import IFTextSkeleton from 'Components/IFText/IFTextSkeleton'

const OperatorUserProfile = ({
  logout,
  operatorUser,
  operatorUserActions,
  fetchOperatorUser,
  fetchOperatorUserRequestState,
  fetchOperatorUserActionsRequestState,
  fetchOperatorUserActions,
  operatorUserActionsPaginationOffset,
  deleteOperatorUser,
  deleteOperatorUserRequestState,
  operatorUserActionsFilters,
  setOperatorUserActionsFilters,
  setChangePasswordOrNameRequestState,
  changePasswordOrNameRequestState,
  changePasswordOrName,
  operator,
  clearOperatorUserActions,
  clearOperatorUserActionsFilters,
  updateOperatorUser,
  updateOperatorUserRequestState,
  fetchOperatorUserActionsUserRequestState,
  fetchOperatorUserActionsUser,
  operatorUserActionsUser,
  operatorUserActionsUserPaginationOffset,
  clearOperatorUserActionsUser,
  clickedOperatorUser,
}) => {
  const convertPermissionsBack = (permissions) => {
    let upperCasePermissions = permissions.map((permission) => {
      let temp = permission.toUpperCase()
      return temp.replace(/ /g, '_')
    })
    let OperatorUserEnums = Object.keys(InfinityEnums.OperatorUserPermission)
    upperCasePermissions = upperCasePermissions.map((permission) => {
      const index = OperatorUserEnums.findIndex(
        (operatorUserEnum) => operatorUserEnum === permission,
      )
      if (index != -1) return index + 1
    })

    return upperCasePermissions
  }
  const transformPermissions = (permissions) => {
    const transformedPermissions = permissions.map((permission) => {
      let lowerCase = permission.toLowerCase()
      lowerCase = lowerCase.replace(/_/g, ' ')
      return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1)
    })
    return transformedPermissions
  }

  const transformPickedPermissions = (permissions) => {
    let OperatorUserEnums = Object.keys(InfinityEnums.OperatorUserPermission)
    OperatorUserEnums = transformPermissions(OperatorUserEnums)
    const transformedPermissions = permissions.map(
      (number) => OperatorUserEnums[number - 1],
    )
    return transformedPermissions
  }
  const arraysAreEqual = (a, b) => {
    if (a.length !== b.length) return false

    const sortedA = [...a].sort()
    const sortedB = [...b].sort()

    return sortedA.every((val, index) => val === sortedB[index])
  }
  const [progress, setProgress] = useState(0)
  const [isFirstLoaded, setIsFirstLoaded] = useState(true)
  const location = useLocation()
  const [isDeadButton, setIsDeadButton] = useState(true)
  const confirmDeleteDialog = useRef()
  const [name, setName] = useState(operatorUser?.name)
  const [currentPermissions, setCureentPermissions] = useState('')
  const showDialogHandlerName = useRef(null)
  const { t } = useTranslation()
  const [isEdit, setIsEdit] = useState(false)
  const showDialogHandlerPassword = useRef(null)
  const [isChanged, setIsChanged] = useState(false)
  const [tablesHeight, setTablesHeight] = React.useState(0)
  const tablesRef = useRef()
  const [selectedPermissions, setSelectedPermissions] = useState([])

  const operatorUserActionsFiltersRef = useRef(null)
  const options = []
  const permissions = transformPermissions(
    Object.keys(InfinityEnums.OperatorUserPermission),
  )
  for (const index in permissions) {
    options.push({
      label: permissions[index],
      value: permissions[index],
    })
  }

  const handleRetry = () => {
    if (Object.keys(clickedOperatorUser).length > 0) {
      fetchOperatorUserActionsUser(
        clickedOperatorUser.id,
        operatorUserActionsFilters,
        operatorUserActionsUserPaginationOffset,
      )
    } else {
      fetchOperatorUserActions(
        operatorUserActionsFilters,
        operatorUserActionsPaginationOffset,
      )
    }
  }
  const loadMoreData = () => {
    if (Object.keys(clickedOperatorUser).length > 0) {
      if (
        fetchOperatorUserActionsUserRequestState === RequestState.LOADING_MORE
      )
        return
      fetchOperatorUserActionsUser(
        clickedOperatorUser.id,
        operatorUserActionsFilters,
        operatorUserActionsUserPaginationOffset,
      )
    } else {
      if (fetchOperatorUserActionsRequestState === RequestState.LOADING_MORE)
        return
      fetchOperatorUserActions(
        operatorUserActionsFilters,
        operatorUserActionsPaginationOffset,
      )
    }
  }
  useEffect(() => {
    const handleResize = (entries) => {
      if (entries[0]) {
        const { height } = entries[0].contentRect
        setTablesHeight(height)
      }
    }

    const resizeObserver = new ResizeObserver(handleResize)

    if (tablesRef.current) {
      resizeObserver.observe(tablesRef.current)
    }

    return () => {
      if (tablesRef.current) {
        resizeObserver.unobserve(tablesRef.current)
      }
    }
  }, [])

  const canEdit = operatorUser.permissions.includes(
    InfinityEnums.OperatorUserPermission.CAN_EDIT_OPERATOR_USER,
  )
  const handleSaveRole = () => {
    const transformedPermissions = convertPermissionsBack(selectedPermissions)
    updateOperatorUser(clickedOperatorUser.id, transformedPermissions)
    setCureentPermissions(selectedPermissions)
  }
  const onSubmitFormHandler = (passwords) => {
    let pass = { old: passwords.oldPassword, new: passwords.confirmPassword }
    changePasswordOrName(operatorUser.name, pass)
  }

  useEffect(() => {
    if (changePasswordOrNameRequestState === RequestState.SUCCEEDED) {
      setIsEdit(false)
    }
  }, [changePasswordOrNameRequestState])
  useEffect(() => {
    if (updateOperatorUserRequestState === RequestState.SUCCEEDED) {
      setCureentPermissions(selectedPermissions)
      setIsChanged(false)
      setIsEdit(false)
      if (Object.keys(clickedOperatorUser).length > 0)
        fetchOperatorUserActionsUser(
          clickedOperatorUser.id,
          operatorUserActionsFilters,
          0,
        )
    }
  }, [updateOperatorUserRequestState])
  useEffect(() => {
    if (location?.state?.refresh) {
      setIsFirstLoaded(true)
      fetchOperatorUser()
      clearOperatorUserActionsFilters()
      clearOperatorUserActions()
    }
  }, [location.state?.refresh])
  useEffect(() => {
    clearOperatorUserActionsFilters()
    if (Object.keys(clickedOperatorUser).length > 0)
      fetchOperatorUserActionsUser(
        clickedOperatorUser.id,
        operatorUserActionsFilters,
        0,
      )
    else fetchOperatorUserActions(operatorUserActionsFilters, 0)
  }, [])
  useEffect(() => {
    setName(operatorUser.name)
    const permissions =
      Object.keys(clickedOperatorUser).length > 0
        ? clickedOperatorUser.permissions || []
        : operatorUser.permissions || []
    const pickedPermissions = transformPickedPermissions(permissions)
    setSelectedPermissions(pickedPermissions)
    setCureentPermissions(pickedPermissions)
  }, [operatorUser, clickedOperatorUser])

  useEffect(() => {
    if (isFirstLoaded) {
      if (
        fetchOperatorUserRequestState === RequestState.LOADING &&
        progress === 0
      )
        setProgress(progress + 10)

      if (fetchOperatorUserRequestState === RequestState.SUCCEEDED) {
        setProgress(100)
        setIsFirstLoaded(false)
      }
      if (
        fetchOperatorUserRequestState !== RequestState.LOADING &&
        fetchOperatorUserRequestState !== RequestState.UNINITIALIZED &&
        fetchOperatorUserRequestState !== RequestState.SUCCEEDED
      )
        setProgress(100)
    }
  }, [fetchOperatorUserRequestState, isFirstLoaded])
  const handleOnChange = (event) => {
    setName(event.target.value)
    if (event.target.value.length > 0) setIsDeadButton(false)
    else setIsDeadButton(true)
  }
  useEffect(() => {
    if (
      changePasswordOrNameRequestState === RequestState.SUCCEEDED &&
      Object.keys(clickedOperatorUser).length <= 0
    ) {
      showDialogHandlerName.current.dismiss()
      setIsDeadButton(true)
      setChangePasswordOrNameRequestState(RequestState.UNINITIALIZED)
      operatorUserActionsFilters?.current?.clearFilter()
      clearOperatorUserActionsFilters()
      fetchOperatorUserActions(operatorUserActionsFilters, 0)
      setName(operatorUser.name)
    }
  }, [changePasswordOrNameRequestState])

  useEffect(() => {
    if (
      changePasswordOrNameRequestState === RequestState.SUCCEEDED &&
      Object.keys(clickedOperatorUser).length <= 0
    ) {
      showDialogHandlerPassword.current.dismiss()
      setChangePasswordOrNameRequestState(RequestState.UNINITIALIZED)
      operatorUserActionsFilters?.current?.clearFilter()
      clearOperatorUserActionsFilters()
      fetchOperatorUserActions(operatorUserActionsFilters, 0)
      setName(operatorUser.name)
    }
  }, [changePasswordOrNameRequestState])
  const logoutHandler = () => {
    logout()
  }

  useEffect(() => {
    if (Object.keys(clickedOperatorUser).length > 0) {
      clearOperatorUserActionsUser()
      fetchOperatorUserActionsUser(
        clickedOperatorUser.id,
        operatorUserActionsFilters,
        0,
      )
    } else {
      clearOperatorUserActions()
      fetchOperatorUserActions(operatorUserActionsFilters, 0)
    }
  }, [operatorUserActionsFilters])
  const onDeleteClickHandler = () => {
    confirmDeleteDialog.current.show()
  }
  const handleDelete = () => {
    deleteOperatorUser(clickedOperatorUser.id)
  }
  useEffect(() => {
    if (deleteOperatorUserRequestState === RequestState.SUCCEEDED) {
      confirmDeleteDialog.current.dismiss()
    }
  }, [deleteOperatorUserRequestState])
  return (
    <div
      className={Styles.WrapperContainer}
      style={
        Object.keys(clickedOperatorUser).length <= 0 ? { padding: '1rem' } : {}
      }
    >
      <div>
        <LoadingBar
          color={Colors.primary}
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
      </div>
      <div
        className={Styles.TopContainer}
        style={{
          backgroundColor: Colors.white,
          borderColor:
            Object.keys(clickedOperatorUser).length > 0
              ? Colors.white
              : Colors.grey,
        }}
      >
        <div className={Styles.UserDataContainer}>
          <div
            className={Styles.UserContainerDiv}
            style={
              Object.keys(clickedOperatorUser).length > 0
                ? {
                    backgroundColor: Colors.white,
                  }
                : {
                    backgroundColor: Colors.white,
                    paddingLeft: '1rem',
                    paddingTop: '1rem',
                    paddingRight: '1rem',
                  }
            }
          >
            <div className={Styles.UserAvatarContainer}>
              <div className={Styles.AvatarContainer}>
                {Object.keys(clickedOperatorUser).length > 0 ? (
                  <IFAvatar name={clickedOperatorUser.name} size={64} />
                ) : fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED ? (
                  <IFSkeleton variant="circular" width="4rem" height="4rem" />
                ) : (
                  <IFAvatar name={operatorUser.name} size={64} />
                )}
                <IFText
                  loadSkeleton={
                    (fetchOperatorUserRequestState === RequestState.LOADING ||
                      fetchOperatorUserRequestState ===
                        RequestState.UNINITIALIZED) &&
                    Object.keys(clickedOperatorUser).length <= 0
                  }
                  skeletonWidth="8rem"
                  skeletonHeight="1.75rem"
                  className={Styles.UserName}
                  style={{
                    color: Colors.black,
                  }}
                >
                  {Object.keys(clickedOperatorUser).length > 0
                    ? clickedOperatorUser.name
                    : operatorUser.name}
                </IFText>
                {Object.keys(clickedOperatorUser).length > 0 ? (
                  <></>
                ) : fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED ? (
                  <></>
                ) : (
                  <Edit
                    className={Styles.EditIcon}
                    fontSize={'small'}
                    onClick={() => {
                      setIsDeadButton(true)
                      setName(operatorUser.name)
                      showDialogHandlerName.current.show()
                    }}
                    style={{
                      color: Colors.StationUptimeStatus.Offline,
                    }}
                  />
                )}
              </div>
              {Object.keys(clickedOperatorUser).length <= 0 ? (
                <div className={Styles.ButtonsDiv}>
                  {fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED ? (
                    <IFSkeleton
                      variant="rectangular"
                      width="4.5rem"
                      height="2.5rem"
                    />
                  ) : (
                    <IFButton
                      color={Colors.primary}
                      isFill={false}
                      isLoading={false}
                      onClick={() => {
                        showDialogHandlerPassword.current.show()
                      }}
                      text={t('OperatorUserProfile.ChangePassword')}
                      size="xsm"
                      width={'9rem'}
                    />
                  )}
                  {fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED ? (
                    <IFSkeleton
                      variant="rectangular"
                      width="4.5rem"
                      height="2.5rem"
                    />
                  ) : (
                    <IFButton
                      color={Colors.red}
                      isFill={false}
                      isLoading={false}
                      onClick={logoutHandler}
                      text={t('OperatorUserProfile.logout')}
                      size="xsm"
                      width={'4.5rem'}
                    />
                  )}
                </div>
              ) : clickedOperatorUser.id !== operatorUser.id && canEdit ? (
                <div className={Styles.ButtonsDiv}>
                  <IFButton
                    color={Colors.red}
                    isFill={false}
                    isLoading={false}
                    size="xsm"
                    onClick={
                      isEdit
                        ? () => {
                            setIsChanged(false)
                            setIsEdit(false)
                            const permissions =
                              Object.keys(clickedOperatorUser).length > 0
                                ? clickedOperatorUser.permissions || []
                                : operatorUser.permissions || []
                            const pickedPermissions =
                              transformPickedPermissions(permissions)
                            setSelectedPermissions(pickedPermissions)
                          }
                        : onDeleteClickHandler
                    }
                    text={
                      isEdit
                        ? t('OperatorUserProfile.CancelEdit')
                        : t('OperatorUserProfile.DeleteRole')
                    }
                    width={'4.386rem'}
                  />
                  <IFButton
                    width={'3.75rem'}
                    color={Colors.primary}
                    isFill={false}
                    isLoading={false}
                    size="xsm"
                    onClick={isEdit ? handleSaveRole : () => setIsEdit(true)}
                    text={
                      isEdit
                        ? t('OperatorUserProfile.SaveRole')
                        : t('OperatorUserProfile.EditRole')
                    }
                    isDead={
                      isEdit &&
                      (!isChanged ||
                        selectedPermissions.length === 0 ||
                        arraysAreEqual(
                          selectedPermissions,
                          transformPickedPermissions(
                            clickedOperatorUser.permissions,
                          ),
                        ))
                    }
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <Scrollbars autoHide className={Styles.ScrollParent}>
          <div
            className={Styles.UserInfoContainer}
            style={
              Object.keys(clickedOperatorUser).length <= 0
                ? { paddingLeft: '1rem' }
                : {}
            }
          >
            <div className={Styles.AllInfoContainer}>
              <div className={Styles.UserInfo}>
                <div className={Styles.InfoText}>
                  <div className={Styles.Item}>
                    <div className={Styles.LabelTitle}>
                      <IFText
                        style={{ color: Colors.gray }}
                        loadSkeleton={
                          (fetchOperatorUserRequestState ===
                            RequestState.LOADING ||
                            fetchOperatorUserRequestState ===
                              RequestState.UNINITIALIZED) &&
                          Object.keys(clickedOperatorUser).length <= 0
                        }
                        skeletonWidth="4rem"
                        skeletonHeight="1.5rem"
                      >
                        {t('OperatorUserProfile.Email')}
                      </IFText>
                    </div>
                    <div className={Styles.LabelValue}>
                      <IFText
                        style={{
                          color: Colors.text,
                        }}
                        loadSkeleton={
                          (fetchOperatorUserRequestState ===
                            RequestState.LOADING ||
                            fetchOperatorUserRequestState ===
                              RequestState.UNINITIALIZED) &&
                          Object.keys(clickedOperatorUser).length <= 0
                        }
                      >
                        {Object.keys(clickedOperatorUser).length > 0
                          ? clickedOperatorUser.email
                          : operatorUser.email}
                      </IFText>
                    </div>
                  </div>
                  <div className={Styles.Item}>
                    <div className={Styles.LabelTitle}>
                      <IFText
                        style={{ color: Colors.gray }}
                        loadSkeleton={
                          (fetchOperatorUserRequestState ===
                            RequestState.LOADING ||
                            fetchOperatorUserRequestState ===
                              RequestState.UNINITIALIZED) &&
                          Object.keys(clickedOperatorUser).length <= 0
                        }
                        skeletonWidth="4rem"
                        skeletonHeight="1.5rem"
                      >
                        {t('OperatorUserProfile.JoinedOn')}
                      </IFText>
                    </div>
                    <div className={Styles.LabelValue}>
                      <IFText
                        style={{
                          color: Colors.text,
                        }}
                        loadSkeleton={
                          (fetchOperatorUserRequestState ===
                            RequestState.LOADING ||
                            fetchOperatorUserRequestState ===
                              RequestState.UNINITIALIZED) &&
                          Object.keys(clickedOperatorUser).length <= 0
                        }
                      >
                        {Object.keys(clickedOperatorUser).length > 0
                          ? moment(clickedOperatorUser.createdAt).format(
                              'MMM DD, YYYY LTS',
                            )
                          : moment(operatorUser.createdAt).format(
                              'MMM DD, YYYY LTS',
                            )}
                      </IFText>
                    </div>
                  </div>
                  <div className={Styles.ItemPerm}>
                    <div className={Styles.LabelTitle}>
                      <IFText
                        style={{ color: Colors.gray }}
                        loadSkeleton={
                          (fetchOperatorUserRequestState ===
                            RequestState.LOADING ||
                            fetchOperatorUserRequestState ===
                              RequestState.UNINITIALIZED) &&
                          Object.keys(clickedOperatorUser).length <= 0
                        }
                        skeletonWidth="4rem"
                        skeletonHeight="1.5rem"
                      >
                        {t('OperatorUserProfile.Role')}
                      </IFText>
                    </div>
                    <div className={Styles.LabelValue}>
                      {Object.keys(clickedOperatorUser).length > 0 && isEdit ? (
                        <FormControl
                          sx={{
                            width: '15rem',
                            borderRadius: '5px',
                          }}
                          onClick={(e) => {
                            e.stopPropagation()
                          }}
                        >
                          <CheckPicker
                            className={Styles.Picker}
                            size="xs"
                            value={selectedPermissions}
                            renderValue={(value) => {
                              const pickedPermissions = value
                              const first = pickedPermissions[0]
                              const count = pickedPermissions.length

                              return (
                                <div className={Styles.Render}>
                                  <IFText className={Styles.RenderText}>
                                    {first ||
                                      t(
                                        'OperatorUserListItem.NoPermissionsSelected',
                                      )}
                                  </IFText>

                                  {count > 1 && (
                                    <IFText style={{ flexShrink: 0 }}>{`+${
                                      count - 1
                                    }`}</IFText>
                                  )}
                                </div>
                              )
                            }}
                            searchable={false}
                            preventOverflow={true}
                            data={options}
                            menuStyle={{
                              color: Colors.text,
                              zIndex: 1500,
                            }}
                            onChange={(e) => {
                              setSelectedPermissions(e)
                              const permissions =
                                Object.keys(clickedOperatorUser).length > 0
                                  ? clickedOperatorUser.permissions || []
                                  : operatorUser.permissions || []
                              const pickedPermissions =
                                transformPickedPermissions(permissions)

                              if (!arraysAreEqual(pickedPermissions, e)) {
                                setIsChanged(true)
                              }
                            }}
                          />
                        </FormControl>
                      ) : (fetchOperatorUserRequestState ===
                          RequestState.LOADING ||
                          fetchOperatorUserRequestState ===
                            RequestState.UNINITIALIZED) &&
                        Object.keys(clickedOperatorUser).length <= 0 ? (
                        <IFTextSkeleton />
                      ) : Object.keys(clickedOperatorUser).length > 0 ? (
                        <IFGroupingComponent
                          componentText={currentPermissions}
                        />
                      ) : (
                        <IFGroupingComponent
                          componentText={currentPermissions}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={Styles.CountryListDiv}
            style={
              Object.keys(clickedOperatorUser).length <= 0
                ? { paddingLeft: '1.75rem' }
                : {}
            }
          >
            <IFText
              loadSkeleton={
                (fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED) &&
                Object.keys(clickedOperatorUser).length <= 0
              }
              skeletonWidth="4rem"
              skeletonHeight="1.5rem"
              className={Styles.CountryName}
              style={{
                color: Colors.text,
                fontWeight: 600,
              }}
            >
              {t('OperatorUserProfile.Countries')}
            </IFText>
            <div className={Styles.CountryList}>
              {Object.keys(clickedOperatorUser).length > 0 ? (
                <div className={Styles.CountryItem}>
                  <ReactCountryFlag
                    className={Styles.FlagItem}
                    countryCode={operator.country.codeTwoLetters}
                    svg
                  />
                  <IFText
                    style={{
                      color: Colors.text,
                    }}
                  >
                    {operator.country.name}
                  </IFText>
                </div>
              ) : (
                <div className={Styles.CountryItem}>
                  {fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED ? (
                    <IFSkeleton
                      variant="rectangular"
                      width="1.25rem"
                      height="1.25rem"
                    />
                  ) : (
                    <ReactCountryFlag
                      className={Styles.FlagItem}
                      countryCode={operator.country.codeTwoLetters}
                      svg
                    />
                  )}

                  <IFText
                    style={{
                      color: Colors.text,
                    }}
                    loadSkeleton={
                      fetchOperatorUserRequestState === RequestState.LOADING ||
                      fetchOperatorUserRequestState ===
                        RequestState.UNINITIALIZED
                    }
                    skeletonWidth="4rem"
                    skeletonHeight="1.5rem"
                  >
                    {operator.country.name}
                  </IFText>
                </div>
              )}
            </div>
          </div>
          <div className={Styles.ActionsListDiv} ref={tablesRef}>
            <IFText
              loadSkeleton={
                (fetchOperatorUserRequestState === RequestState.LOADING ||
                  fetchOperatorUserRequestState ===
                    RequestState.UNINITIALIZED) &&
                Object.keys(clickedOperatorUser).length <= 0
              }
              skeletonWidth="4rem"
              skeletonHeight="1.5rem"
              className={Styles.CountryName}
              style={{
                color: Colors.text,
                fontWeight: 600,
              }}
            >
              {t('OperatorUserProfile.Actions')}
            </IFText>
            <div className={Styles.Filter}>
              <IFFilter
                isLoading={
                  (fetchOperatorUserRequestState === RequestState.LOADING ||
                    fetchOperatorUserRequestState ===
                      RequestState.UNINITIALIZED) &&
                  Object.keys(clickedOperatorUser).length <= 0
                }
                ref={operatorUserActionsFiltersRef}
                onFilterChange={(newFilter) => {
                  if (Object.keys(clickedOperatorUser).length > 0) {
                    clearOperatorUserActionsUser()
                    clearOperatorUserActionsFilters()
                    setOperatorUserActionsFilters(newFilter)
                    fetchOperatorUserActionsUser(
                      clickedOperatorUser.id,
                      newFilter,
                      0,
                    )
                  } else {
                    clearOperatorUserActions()
                    clearOperatorUserActionsFilters()
                    setOperatorUserActionsFilters(newFilter)
                    fetchOperatorUserActions(newFilter, 0)
                  }
                }}
                filters={operatorUserActionsFilters}
                textFieldPlaceholder={t(
                  'OperatorUserProfile.ActionsFilterPlaceHolder',
                )}
                disableFutureDates={true}
              />
            </div>
            <div className={Styles.ListWrapper}>
              <OperatorUserActionList
                operatorUserActions={
                  Object.keys(clickedOperatorUser).length > 0
                    ? operatorUserActionsUser
                    : operatorUserActions
                }
                paginationOffset={
                  Object.keys(clickedOperatorUser).length > 0
                    ? operatorUserActionsUserPaginationOffset
                    : operatorUserActionsPaginationOffset
                }
                fetchOperatorUserActionsRequestState={
                  Object.keys(clickedOperatorUser).length > 0
                    ? fetchOperatorUserActionsUserRequestState
                    : fetchOperatorUserActionsRequestState
                }
                operatorUserActionsType={InfinityEnums.OperatorUserActionType}
                loadMoreData={() => loadMoreData()}
                handleRetry={() => handleRetry()}
                tablesHeight={tablesHeight}
                clickedOperatorUser={clickedOperatorUser}
                operatorUser={operatorUser}
              />
            </div>
          </div>
        </Scrollbars>
      </div>
      <IFDialog
        ref={showDialogHandlerName}
        dialogWidth="32rem"
        title={t('OperatorUserProfile.EditUserNameTitle')}
        onAction={() => {
          changePasswordOrName(name, undefined, () => {
            fetchOperatorUser()
          })
        }}
        isDead={isDeadButton || name === operatorUser.name}
        buttonCancelColor={Colors.primary}
        actionButtonText={t('OperatorUserProfile.EditUserNameConfirm')}
        actionButtonColor={Colors.primary}
        buttonClassName={Styles.ButtonPhoneEditModal}
        isLoading={changePasswordOrNameRequestState === RequestState.LOADING}
        onDismiss={() => {
          setName(operatorUser.name)
        }}
        subtitle={
          <div className={Styles.UserNameField}>
            <TextField
              value={name}
              id="outlined-basic"
              label={t('OperatorUserProfile.EditUserNameLabel')}
              variant="outlined"
              type="text"
              onChange={handleOnChange}
              sx={{
                width: '100%',
                '& label.Mui-focused': {
                  color: Colors.text,
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: Colors.grey,
                    borderWidth: 1,
                  },
                  '&:hover fieldset': {
                    borderColor: Colors.primary,
                    borderWidth: 1,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: Colors.primary,
                    borderWidth: 1,
                  },
                },
              }}
            />
          </div>
        }
      ></IFDialog>
      <IFModal
        title={t('OperatorUserProfile.ChangePassword')}
        open={false}
        ref={showDialogHandlerPassword}
      >
        <ChangePasswordForm
          onSubmitForm={(values) => onSubmitFormHandler(values)}
        />
      </IFModal>
      <IFDialog
        ref={confirmDeleteDialog}
        dialogWidth="32rem"
        title={t('OperatorUserProfile.deleteModalTitle')}
        subtitle={t('OperatorUserProfile.deleteModalText')}
        buttonCancelColor={Colors.primary}
        actionButtonColor={Colors.red}
        actionButtonText={t('OperatorUserProfile.deleteModalConfirm')}
        buttonClassName={Styles.Button}
        isLoading={deleteOperatorUserRequestState === RequestState.LOADING}
        onAction={handleDelete}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  operatorUser: AuthSelectors.getOperatorUser(state),
  operatorUserActions:
    OperatorUserActionsSelectors.getOperatorUserActions(state),
  fetchOperatorUserRequestState:
    AuthSelectors.getFetchOperatorUserRequestState(state),
  fetchOperatorUserActionsRequestState:
    OperatorUserActionsSelectors.getFetchOperatorUserActionsRequestState(state),
  deleteOperatorUserRequestState:
    OperatorUserSelectors.getDeleteOperatorUserRequestState(state),
  operatorUserActionsFilters:
    OperatorUserActionsSelectors.getOperatorUserActionsFilters(state),
  changePasswordOrNameRequestState:
    OperatorUserSelectors.getChangePasswordOrNameRequestState(state),
  operator: AuthSelectors.getOperator(state),
  updateOperatorUserRequestState:
    OperatorUserSelectors.getUpdateOperatorUserRequestState(state),
  operatorUserActionsPaginationOffset:
    OperatorUserActionsSelectors.getOperatorUserActionsPaginationOffset(state),
  operatorUserActionsUser:
    OperatorUserActionsSelectors.getOperatorUserActionsUser(state),
  fetchOperatorUserActionsUserRequestState:
    OperatorUserActionsSelectors.getFetchOperatorUserActionsUserRequestState(
      state,
    ),
  operatorUserActionsUserPaginationOffset:
    OperatorUserActionsSelectors.getOperatorUserActionsUserPaginationOffset(
      state,
    ),
  clickedOperatorUser: OperatorUserSelectors.getClickedOperatorUser(state),
})
function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(AuthActions.operatorUserLogout()),
    fetchOperatorUser: () => dispatch(AuthActions.fetchOperatorUser()),
    fetchOperatorUserActions: (filter, offset) =>
      dispatch(
        OperatorUserActionsActions.fetchOperatorUserActions(filter, offset),
      ),
    deleteOperatorUser: (operatorUserId, ref) =>
      dispatch(OperatorUserAction.deleteOperatorUser(operatorUserId, ref)),
    setOperatorUserActionsFilters: (newFilter) =>
      dispatch(
        OperatorUserActionsActions.setOperatorUserActionsFilters(newFilter),
      ),
    setChangePasswordOrNameRequestState: (newRequestState) =>
      dispatch(
        OperatorUserAction.setChangePasswordOrNameRequestState(newRequestState),
      ),
    changePasswordOrName: (name, password, onResponse) =>
      dispatch(
        OperatorUserAction.changePasswordOrName(name, password, onResponse),
      ),
    clearOperatorUserActions: () =>
      dispatch(OperatorUserActionsActions.clearOperatorUserActions()),
    clearOperatorUserActionsFilters: () =>
      dispatch(OperatorUserActionsActions.clearOperatorUserActionsFilters()),
    updateOperatorUser: (operatorUserId, permissions) =>
      dispatch(
        OperatorUserAction.updateOperatorUser(operatorUserId, permissions),
      ),
    fetchOperatorUserActionsUser: (userId, filter, offset) =>
      dispatch(
        OperatorUserActionsActions.fetchOperatorUserActionsUser(
          userId,
          filter,
          offset,
        ),
      ),
    clearOperatorUserActionsUser: () =>
      dispatch(OperatorUserActionsActions.clearOperatorUserActionsUser()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OperatorUserProfile)
